export enum ElevationTokensEnum {
  ELEVATION_1 = "elevation-1",
  ELEVATION_2 = "elevation-2",
  ELEVATION_3 = "elevation-3",
}
